import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NavigationLink } from '@stylehaven/components';

@Component({
    standalone: false,
    selector: 'digihaven-dashboard-title',
    templateUrl: './dashboard-title.component.html',
    styleUrls: ['./dashboard-title.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardTitleComponent {
    @Input()
    title!: string;

    @Input()
    icon!: string;

    @Input()
    navigationLink!: NavigationLink;

    @Input()
    totalItems = 0;
}
